import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { getRelativeEventTimestamp } from "@faire/web/common/performance/getRelativeEventTimestamp";

import { isElementPartiallyInViewport } from "./isElementInViewport";

export const getFaireImageIdentifier = (target: HTMLImageElement) => {
  return (
    target.getAttribute("data-faire-image-id") || target.srcset || target.src
  );
};

export const getSetOfImageIdentifiers = (
  targetElements: Array<HTMLElement>,
  shouldIncludeAllImages?: boolean
): {
  numImages: number;
  pendingImageUrls: Set<string>;
  lastImageLoadTime: DOMHighResTimeStamp | undefined;
} => {
  const window = getWindowOrThrow();
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  const isImageVisible = (img: HTMLImageElement) => {
    if (isElementPartiallyInViewport(img, windowHeight, windowWidth)) {
      const style = window.getComputedStyle(img);
      return style.visibility !== "hidden";
    }
    return false;
  };

  const imgs = new Array<HTMLImageElement>()
    .concat(
      ...targetElements.map((element) =>
        Array.from(element.querySelectorAll("img"))
      )
    )
    .filter((img) => !img.src.startsWith("data:"));

  const numImages = imgs.length;

  const includedImages = shouldIncludeAllImages
    ? imgs
    : imgs.filter(isImageVisible);

  const imageLoadTimes = includedImages.map(
    (img) => (img as any).faireLoadTimeStamp as number
  );
  const lastImageLoadTime = Math.max(...imageLoadTimes.filter(isFinite));

  return {
    numImages,
    pendingImageUrls: new Set(
      includedImages
        .filter((img) => !img.complete)
        .map((img) => getFaireImageIdentifier(img))
    ),
    lastImageLoadTime:
      isFinite(lastImageLoadTime) && lastImageLoadTime > 0
        ? getRelativeEventTimestamp(lastImageLoadTime)
        : undefined,
  };
};
